import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ALL, deviceTypeOptions, deviceTypeWithAllOptions } from '~/features/base/constants/filterOptions';
import RadioButton from '@rio-cloud/rio-uikit/RadioButton';
import { SelectOption } from '@rio-cloud/rio-uikit/Select';
import SelectOTA from '~/features/base/components/forms/ota/SelectOTA';

interface option {
    id: string;
    value: string;
    label: string | React.JSX.Element;
}

interface DeviceTypeFormItemProps {
    label?: string;
    value?: string;
    showOptionAll?: boolean;
    onChange: (item: { deviceType: string | undefined } | SelectOption | undefined) => void;
    isRadioBtnGroup?: boolean;
    hasError?: boolean;
    errorMsg?: string;
}

const DeviceTypeFormItem: FC<DeviceTypeFormItemProps> = ({
                                                             label = 'intl-msg:deviceType',
                                                             value = ALL,
                                                             showOptionAll = false,
                                                             onChange,
                                                             isRadioBtnGroup = false,
                                                             hasError = false,
                                                             errorMsg = 'intl-msg:deviceType.error'

                                                         }) => {

    const handleChange = (item: option) => {
        onChange({
            deviceType: item.id === ALL ? undefined : item.value,
        });
    };
    const isSelected = (item) => {
        return item.id === ALL && value === undefined || item.value === value;
    }
    const getSelectedClass = item =>
        isSelected(item) ? 'border-color-highlight bg-highlight text-color-white' : 'hover-bg-highlight-decent';

    const options = showOptionAll ? deviceTypeWithAllOptions : deviceTypeOptions;

    const formGroupClass = hasError ? 'form-group has-feedback has-error' : 'form-group';

    if (isRadioBtnGroup) {
        return (
            <div className='btn-toolbar'>
                {
                    options.map(item =>(
                        <RadioButton
                            name='noTickRadioBoxes'
                            custom
                            className={`width-70 padding-5 border rounded ${getSelectedClass(item)}`}
                            onChange={() => handleChange(item)}
                            checked={isSelected(item)}
                        >
                            <div className='text-center text-size-14 text-medium'>{item.label}</div>
                        </RadioButton>
                    ))
                }
            </div>
        )
    }

    return (
        <div className={formGroupClass}>
            <label className='control-label'>
                <FormattedMessage id={label}/>
            </label>
            <SelectOTA
                options={options}
                value={[value]}
                onChange={(selectedOption) => {
                    onChange(selectedOption?.value);
                }}
                placeholder='Enter device type'
            />
            {hasError &&
                <div className={'form-group has-feedback has-error padding-bottom-15 padding-top-15'}>
                        <span className='help-block'>
                        <span><FormattedMessage id={errorMsg}/></span>
                        </span>
                </div>
            }
        </div>
    );
};

export default DeviceTypeFormItem;
